import React from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { FormattedMessage } from "react-intl"
import { DialogContentText, DialogTitle } from "@carrotfertility/carotene-core"
import { Form, DialogActionsBar, FormOnSubmitHandler } from "@carrotfertility/carotene-core-x"
import { ArrowSubmitButton } from "../shared/layouts"
import { InternationalAddress, InternationalAddressFields } from "#/services/common-forms"
import { carrotClient } from "#/utils/CarrotClient"

function canSkip(user: ReturnType<typeof useCurrentUser>): boolean {
  return (
    Boolean(user?.internationalAddressLine) &&
    Boolean(user?.internationalCountry) &&
    Boolean(user?.city) &&
    Boolean(user?.state)
  )
}

export const InternationalAddressUpdate = (): JSX.Element => {
  const user = useCurrentUser()
  const { send } = useStateMachine(canSkip(user) ? "" : null)

  const onSubmit: FormOnSubmitHandler<InternationalAddressFields> = async (data): Promise<void> => {
    await carrotClient.updateUser({
      address1: null,
      address2: null,
      city: data?.city,
      state: data?.state,
      zip: data?.zip,
      internationalCountry: data?.internationalCountry?.value,
      internationalAddressLine: data?.internationalAddressLine
    })
    user?.refreshUserInfo()
    send("")
  }
  return (
    <>
      <DialogTitle>
        <FormattedMessage defaultMessage="Confirm your address" />
      </DialogTitle>
      <DialogContentText paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}>
        <FormattedMessage defaultMessage="Please confirm or update your address so that we can reimburse you." />
      </DialogContentText>
      <Form onSubmit={onSubmit}>
        <InternationalAddress
          defaultValues={{
            city: user?.city,
            state: user?.state,
            zip: user?.zip,
            internationalCountry: user?.internationalCountry,
            internationalAddressLine: user?.internationalAddressLine
          }}
        />
        <DialogActionsBar
          primaryAction={
            <ArrowSubmitButton>
              <FormattedMessage defaultMessage="Continue" />
            </ArrowSubmitButton>
          }
        />
      </Form>
    </>
  )
}
